import {
  FontWeights,
  IComboBoxStyles,
  ISearchBoxStyles,
  IStackStyles,
} from "@fluentui/react";

export const TextFieldStyles = {
  fieldGroup: {
    width: "290px",
  },
};

export const TextGrayFieldStyles = {
  fieldGroup: {
    width: "290px",
    backgroundColor: "lightgray",
  },
};

export const NextButtonStyle = {
  width: "100px",
  padding: "10px",
  marginBottom: "20px",
};

export const NextButtonStyleCustomerAccount = {
  width: "100px",
  padding: "10px",
  marginLeft: "1000px",
  marginBottom: "20px",
};

export const BackButtonStyleBilling = {
  width: "100px",
  padding: "10px",
  marginLeft: "900px",
  marginBottom: "20px",
};

export const BackButtonStyleShipping = {
  width: "100px",
  padding: "10px",
  marginLeft: "900px",
  marginTop: "20px",
};

export const SaveButtonStyleShipping = {
  width: "10px",
  marginTop: "20px",
  padding: "10px",
  marginBottom: "20px",
};

export const CheckBoxStyle = {
  root: {
    marginTop: "12px",
    width: "max-content",
  },
  checkbox: {
    height: "15px",
    width: "15px",
    marginTop: "4px",
    marginLeft: "1px",
  },
  text: {
    fontSize: "14px",
    fontWeight: "600",
  },
};

export const ButtonStyle = {
  width: "100px",
  marginTop: "20px",
  padding: "10px",
};

export const CreateFormStyle = {
  marginLeft: "20px",
  marginRight: "10px",
};

export const MediumTextFieldStyles = {
  fieldGroup: {
    width: "250px",
  },
};

export const DisabledMediumTextFieldStyles = {
  fieldGroup: {
    width: "250px",
    background: "lightgray",
  },
};

export const PanelCheckBoxStyle = {
  root: {
    marginTop: "12px",
    width: "max-content",
  },
  checkbox: {
    height: "15px",
    width: "15px",
    marginTop: "28px",
    marginLeft: "10px",
  },
  text: {
    fontSize: "14px",
    fontWeight: "600",
    marginTop: "24px",
  },
};

export const NextButtonStyleEditContact = {
  width: "100px",
  padding: "10px",
  marginBottom: "20px",
  marginLeft: "1000px",
};

export const EditScreenButtonStyle = {
  width: "100px",
  marginTop: "20px",
  padding: "10px",
  marginBottom: "20px",
};

export const SaveAndNextButtonStyleShipping = {
  marginTop: "20px",
  padding: "10px",
  marginBottom: "20px",
};

export const ComboBoxStyles: Partial<IComboBoxStyles> = {
  root: {
    width: 180,
    height: 24,
  },
};

export const IdStyles = { fieldGroup: { width: "200px" } };

export const DiscountCalendarStyles = {
  root: { height: "5px" },
  icon: { padding: "0px 0px 0px" },
  readOnlyTextField: { lineHeight: "18px" },
  textField: {
    "& .ms-TextField-fieldGroup": {
      width: "140px",
      borderColor: "rgb(50, 49, 48)",
      height: "23px",
      marginLeft: "30px",
    },
    "& .ms-TextField-field": {
      padding: "0px 20px 0px 8px",
    },
  },
};

export const CheckBoxStyles = {
  root: {
    "& .ms-Checkbox-checkbox": {
      "& .ms-Checkbox-text": {
        fontWeight: FontWeights.semibold,
        marginBottom: "10px",
      },
    },
  },
};

export const CreateQuoteStyle = {
  marginTop: "20px",
  padding: "10px",
  marginBottom: "20px",
};

export const DiscountComboBoxStyles: Partial<IComboBoxStyles> = {
  root: {
    width: 100,
    height: 24,
  },
};

export const EditComboBoxStyles: Partial<IComboBoxStyles> = {
  root: {
    width: 290,
  },
};

export const disbaledComboBoxStyles: Partial<IComboBoxStyles> = {
  root: {
    width: 290,
    borderColor: "rgb(50, 49, 48)",
    color: "rgb(50, 49, 48)",
    "& .ms-ComboBox-container": {
      borderColor: "rgb(50, 49, 48)",
      "& .ms-ComboBox": {
        borderWidth: 1,
        borderColor: "rgb(50, 49, 48)",
        paddingLeft: "0",
      },
      "& .css": {
        paddingLeft: "-9px",
      },
    },
    div: {
      borderWidth: 1,
      borderColor: "rgb(50, 49, 48)",
    },
    "& .ms-ComboBox": {
      borderWidth: 1,
      borderColor: "rgb(50, 49, 48)",
      paddingLeft: "-9px",
      "& input": {
        color: "rgb(50, 49, 48)",
        // backgroundColor: 'lightgray',
        paddingLeft: "-9px",
      },
      "& button": {
        // backgroundColor: 'lightgray',
        "& span": {
          // backgroundColor: 'lightgray',
          "& i": {
            color: "rgb(50, 49, 48)",
            // backgroundColor: 'lightgray',
          },
        },
      },
    },
    "& .css": {
      paddingLeft: 0,
      // marginLeft: "9px",
    },
  },
  container: {
    borderColor: "rgb(50, 49, 48)",
    color: "rgb(50, 49, 48)",
  },
  label: {
    color: "rgb(50, 49, 48)",
  },
  input: {
    borderColor: "rgb(50, 49, 48)",
    color: "rgb(50, 49, 48)",
    paddingLeft: "-9px",
  },
};

export const EditContactHeadingStyle = {
  marginBottom: "10px",
  marginTop: "2px",
  width: "200px",
};

export const EditButtonStyle = {
  width: "50px",
  marginTop: "10px",
  padding: "5px",
};

export const SaveAndBackButtonStyleShipping = {
  marginTop: "20px",
  marginBottom: "100px",
  width: "120px",
  marginLeft: "500px",
};

export const ContactsComboBoxStyles: Partial<IComboBoxStyles> = {
  root: {
    width: 250,
    height: 24,
  },
};

export const RegisterCountryBoxStyles: Partial<IComboBoxStyles> = {
  root: {
    width: 250,
  },
};

export const DisabledRegisterCountryBoxStyles: Partial<IComboBoxStyles> = {
  root: {
    width: 250,
    borderColor: "rgb(50, 49, 48)",
    color: "rgb(50, 49, 48)",
    "& .ms-ComboBox": {
      borderWidth: 1,
      borderColor: "rgb(50, 49, 48)",
      paddingLeft: "-9px",
      "& input": {
        color: "rgb(50, 49, 48)",
        // backgroundColor: 'lightgray',
        paddingLeft: "-9px",
      },
      "& button": {
        // backgroundColor: 'lightgray',
        "& span": {
          // backgroundColor: 'lightgray',
          "& i": {
            color: "rgb(50, 49, 48)",
            // backgroundColor: 'lightgray',
          },
        },
      },
    },
  },
  label: {
    color: "rgb(50, 49, 48)",
  },
};

export const CustomerAccountStakStyle: IStackStyles = {
  root: {
    overflowX: "hidden",
  },
};

export const searchBoxIconWidthStyles: Partial<ISearchBoxStyles> = {
  root: { width: '45px', height: '32px', minHeight: '32px' },
};

export const searchBoxWidthStyles: Partial<ISearchBoxStyles> = {
  root: { width: '800px', height: '32px', minHeight: '32px' }, // Increased by 262px more (total 400px increase from original 400px)
};

export const searchIconStyle = {
  color: "rgb(0, 90, 158)",
  fontSize: "16px",
  marginLeft: "5px",
  marginTop: "0px",
  padding: "8px",
  cursor: "pointer",
  borderTopRightRadius: "5px",
  borderBottomRightRadius: "5px",
  height: "32px", // Match SearchBox height
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box" as const
};
